"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_LOCALES = exports.UNSUPPORTED_LOCALES = exports.TMS_SUPPORTED_LOCALES = void 0;
exports.TMS_SUPPORTED_LOCALES = [
    "de-DE",
    "en-AU",
    "en-CA",
    "en-GB",
    "en",
    "es-ES",
    "es",
    "fr-CA",
    "fr-FR",
    "is-IS",
    "ja-JP",
    "pl-PL",
    "pseudo",
    "pt-BR",
    "th-TH",
    "zh-SG",
];
exports.UNSUPPORTED_LOCALES = ["en-AE", "en-SG"];
exports.ALL_LOCALES = [...exports.TMS_SUPPORTED_LOCALES, ...exports.UNSUPPORTED_LOCALES];
//# sourceMappingURL=Formatter.types.js.map